import React, { useState, useEffect } from "react";
import { CircularProgress, Typography, Container } from "@material-ui/core";
import CardPost from "./CardPost";
import FullTextDialog from "./FullTextDialog";
import InfiniteScroll from "react-infinite-scroll-component";
import CheckIcon from "@material-ui/icons/CheckCircleOutlineOutlined";

const AllPostsConnector = () => {
  const [isFullCardOpen, setIsFullCardOpen] = useState(false);
  const [newsDetail, setNewsDetail] = useState();

  const handleDialog = () => setIsFullCardOpen((oldState) => !oldState);

  const [data, setData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const fetchData = () => {
    fetch(`/wp-json/wp/v2/posts/?page=${page}`)
      .then((r) => r.json())
      .then((response) => {
        response.length === 10 ? setHasMore(true) : setHasMore(false);
        response.length === 10 && setPage(page + 1);
        setData([...data, ...response]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(fetchData, []);

  return (
    <>
      {newsDetail && (
        <FullTextDialog
          open={isFullCardOpen}
          onClose={handleDialog}
          bodyText={newsDetail.content.rendered}
          headerText={newsDetail.title.rendered}
          postExcerpt={newsDetail.excerpt.rendered}
          date={newsDetail.date}
        />
      )}
      <InfiniteScroll
        dataLength={data.length}
        next={fetchData}
        hasMore={hasMore}
        loader={
          <div style={{ textAlign: "center", padding: 40 }}>
            <CircularProgress size={40} disableShrink />
          </div>
        }
        endMessage={
          <div
            style={{
              textAlign: "center",
              margin: 20,
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              {data.length > 0 ? (
                <>
                  <Typography variant="subtitle2" style={{ marginRight: 5 }}>
                    {window.t["All posts loaded"]}
                  </Typography>
                  <CheckIcon color="primary" fontSize="small" />
                </>
              ) : (
                <Typography variant="subtitle2" style={{ marginRight: 5 }}>
                  {window.t["No posts were found"]}
                </Typography>
              )}
            </div>
          </div>
        }
      >
        <Container>
          {data.length > 0 &&
            data.map((post, i) => (
              <div style={{ paddingTop: 20, paddingBottom: 20 }} key={i}>
                <CardPost
                  key={i}
                  bodyText={post.content.rendered}
                  headerText={post.title.rendered}
                  postExcerpt={post.excerpt.rendered}
                  date={post.date}
                  onClick={() => {
                    setNewsDetail({ ...post });
                    handleDialog();
                  }}
                />
              </div>
            ))}
        </Container>
      </InfiniteScroll>
    </>
  );
};

export default AllPostsConnector;
